import { gql } from "@apollo/client";

const CREATE_NOTIFICATION = gql`
  mutation createNotification($notification: NotificationCreateInput!) {
    createNotification(notification: $notification) {
      success
      message
      notification {
        id
      }
    }
  }
`;

export { CREATE_NOTIFICATION };
